import React, { FC, useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

import { IData, IDataItem } from '../UserBalanceTableLists'
import { useRest } from '../../../../components/Context'
import { TableSmall } from '../../../../components/TableSmall'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    paddingTop: theme.spacing(4),
    width: '100%',
    height: '100%',
    minWidth: 400,
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    maxWidth: '100%',
    maxHeight: 40,
  },
  title: {
    paddingBottom: theme.spacing(2),
  },
  section: {
    width: '100%',
    height: '100%',
    padding: '16px 32px 32px',
    background: 'rgba(216, 216, 216, 0.05)',
    flexDirection: 'column',
  },
}))

interface UserBalanceSectionProps {
  title: string
  id: string | undefined
  companyId?: string | undefined
  data: IData
}

export const UserBalanceSection: FC<UserBalanceSectionProps> = ({ title, id, companyId, data }) => {
  const classes = useStyles()
  const { rxiosGeneral } = useRest()

  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<IDataItem[]>()

  const loadData = useCallback(async () => {
    if (id) {
      let cleanupFunction = false
      setLoading(true)

      rxiosGeneral.get(data.request(id, companyId)).subscribe(
        // eslint-disable-next-line
        (next: any) => {
          setValues(next.data)
          if (!cleanupFunction) setLoading(false)
        },
        (error) => {
          toast.error(error)
          setLoading(false)
        },
        () => {
          setLoading(false)
        },
      )
      cleanupFunction = true
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    ;(async () => {
      await loadData()
    })()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Grid item xs={12} className={classes.formWrap}>
        <Grid item xs={12} className={classes.container}>
          <Typography variant={'h6'} className={classes.title}>
            {title}
          </Typography>
        </Grid>

        <Grid item xs={12} className={classes.section}>
          <TableSmall columns={data.columns} data={values} textAlign={'left'} loading={loading} />
        </Grid>
      </Grid>
    </>
  )
}
